import { Box, LinearProgress, linearProgressClasses } from '@mui/material'
import React, { useEffect } from 'react'
import CheckIcon from '@mui/icons-material/Check';
import { styled } from '@mui/material/styles';
import { MenuIcon } from '../../../../../core/icon/__refactored/Icon';
import { rqx } from '../../../../../core/request/API';
import { env } from '../../../../../core/Env';

export const Info = ({openWidth, wideHandler, __LOCATION, information_state, uid, tool_state }) => {
    let urlParams = new URLSearchParams(window.location.search);
    const info = information_state.info
    const inf = information_state.info.data.data
    const tc = information_state.tc
    // eslint-disable-next-line
    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 4,
        [`&.${linearProgressClasses.colorPrimary}`]: {
          backgroundColor: "#FFF",
        },
        [`& .${linearProgressClasses.bar}`]: {
          backgroundColor: '#1893F1',
        },
      }));

    const _init = async() =>{
        const dataa = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_view_training`, {training_id:urlParams.get('id'), ref:'trainings', company_id: tool_state.cinfo.data[0].company_id})
        const status = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_status`, {training_id:urlParams.get('id'), user_id: uid, ref:'trainings', company_id: tool_state.cinfo.data[0].company_id })
        const tContent = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_content`, {training_id:urlParams.get('id'), ref:'trainings'})
        const progress = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_check_trainings`, {training_id:urlParams.get('id'), user_id: uid, ref:'trainings', company_id: tool_state.cinfo.data[0].company_id })
        const fields = ['pretest_id', 'quiz_id', 'post_evaluation_id'];
        const countNonNull = fields.reduce((acc, field) => acc + (tContent[0][field] !== null ? 1 : 0), 0) + 1;
        const progressCount = progress.filter(item => item.progress_status === 1).length;
        const percentage = (progressCount / (countNonNull / 100));

        const updatedProg = { pretest: 0, vl: 0, quiz: 0, posteval: 0 };
        progress.forEach(item => {
            if (item.exam_type === 1) {
                updatedProg.pretest = 1;
            } else if (item.exam_type === 2) {
                updatedProg.quiz = 1;
            } else if (item.exam_type === 3) {
                updatedProg.posteval = 1;
            } else if (item.exam_type === 4) {
                updatedProg.vl = 1;
            }
        });

        information_state.prog.set(updatedProg)
        tc.set({...tc.data, status:status.status, progress: percentage, pretest:tContent[0].pretest_id !== null ? 1 : null, quiz:tContent[0].quiz_id !== null? 1: null, posteval:tContent[0].post_evaluation_id !== null ? 1 : null})
        info.set({...info.data, data:dataa})

    }
    
    useEffect(() => {
        _init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        inf.length > 0 && (
            <Box display="flex" flexDirection="column" sx={{ width: openWidth.data ? '479px' : '0px', transition: 'width 0.3s ease', boxShadow: '0px 0px 4px rgba(233, 240, 251, 1)', py: openWidth.data && '40px', px: openWidth.data && '38px', }}>
                <Box display="flex" className='c-pointer' onClick={wideHandler} mb="40px">
                    <MenuIcon />
                    <Box fontSize={14} fontWeight={600} lineHeight="22.65px" color="#1893F1" ml="12px">Hide menu</Box>
                </Box>
                <Box fontSize={24} fontWeight={700} lineHeight="38px">
                    {inf[0].title}
                </Box>
                <Box fontSize={14} fontWeight={400} lineHeight="23px">
                    {inf[0].description}
                </Box>
                {/* <Box bgcolor="#E9F0FB" borderRadius="6px" mt="40px" p="16px">
                    <Box fontSize={14} fontWeight={600} lineHeight="22.65px" color="#1893F1">
                        Your learning progress: {tc.data.progress}%
                    </Box>
                    <Box my="16px" sx={{ width: '100%', mr: 1 }}>
                        <BorderLinearProgress variant="determinate" value={tc.data.progress}  />
                    </Box>
                </Box> */}
                <Box mt="40px">
                    {tc.data.pretest !== null && (
                        <Box display="flex" justifyContent="space-between" bgcolor={__LOCATION === '/take-training-course/pretest' && '#E9F0FB'} borderRadius="8px" p="16px">
                            <Box fontSize={14} fontWeight={400} lineHeight="23px" color={__LOCATION === '/take-training-course/pretest' ? "#1893F1" : "B1C2D2" }>Pretests</Box>
                            {information_state.prog.data.pretest === 1 && (
                                <Box display="flex" justifyContent="center" alignItems="center" width="20px" height="20px" borderRadius="50%" p="2px" bgcolor="#0D62BE">
                                    <CheckIcon sx={{color:"#fff", height:"12px", width:"12px"}} size="small"/>
                                </Box>
                            )}
                        </Box>
                    )}
                    {inf[0].mode_of_conduct !== 2 && (
                        <Box display="flex" justifyContent="space-between" bgcolor={__LOCATION === '/take-training-course/video-lesson' && '#E9F0FB'} border="1px solid #E9F0FB" borderRadius="8px" p="16px" mt="12px">
                            <Box fontSize={14} fontWeight={400} lineHeight="23px" color={__LOCATION === '/take-training-course/video-lesson' ? "#1893F1" : "B1C2D2" }>Video Lesson</Box>
                            {information_state.prog.data.vl === 1 && (
                                <Box display="flex" justifyContent="center" alignItems="center" width="20px" height="20px" borderRadius="50%" p="2px" bgcolor="#0D62BE">
                                    <CheckIcon sx={{color:"#fff", height:"12px", width:"12px"}} size="small"/>
                                </Box>
                            )}
                        </Box>
                    )}
                    {tc.data.quiz !== null && (
                        <Box display="flex" justifyContent="space-between" bgcolor={__LOCATION === '/take-training-course/quiz' && '#E9F0FB'} border="1px solid #E9F0FB" borderRadius="8px" p="16px" mt="12px">
                            <Box fontSize={14} fontWeight={400} lineHeight="23px" color={__LOCATION === '/take-training-course/quiz' ? "#1893F1" : "B1C2D2" }>Quiz</Box>
                            {information_state.prog.data.quiz === 1 && (
                                <Box display="flex" justifyContent="center" alignItems="center" width="20px" height="20px" borderRadius="50%" p="2px" bgcolor="#0D62BE">
                                    <CheckIcon sx={{color:"#fff", height:"12px", width:"12px"}} size="small"/>
                                </Box>
                            )}
                        </Box>
                    )}
                    {tc.data.posteval !== null && (
                        <Box display="flex" justifyContent="space-between" bgcolor={__LOCATION === '/take-training-course/post-evaluation' && '#E9F0FB'} border="1px solid #E9F0FB" borderRadius="8px" p="16px" mt="12px">
                            <Box fontSize={14} fontWeight={400} lineHeight="23px" color={__LOCATION === '/take-training-course/post-evaluation' ? "#1893F1" : "B1C2D2" }>Post Evaluation</Box>
                            {information_state.prog.data.posteval === 1 && (
                                <Box display="flex" justifyContent="center" alignItems="center" width="20px" height="20px" borderRadius="50%" p="2px" bgcolor="#0D62BE">
                                    <CheckIcon sx={{color:"#fff", height:"12px", width:"12px"}} size="small"/>
                                </Box>
                            )}
                        </Box>
                    )}
                </Box>
            </Box>
        )
    )
}   
